// Maintain and distribute overarching organization filter data
(function () {
  'use strict';
  angular.module('obex').
  factory('orgFilterService', ['$q', '$window', 'organizations', 'authService', 
    function ($q, $window, organizations, authService) {
      const storage = $window.localStorage;
      let filtered_organization = {};
      return {
        getSupportsOrganizationMap() {
          const member = authService.getLoginMember();
          const supportsOrganizationInfo = member.SupportsOrganizations.concat(member.Organization);
          const supportsOrganizationMap = supportsOrganizationInfo.map(function (org) {
            return {
              name: org.Name,
              id: org.Id,
            };
          });
          console.log('Got Supports Organization Map');
          return supportsOrganizationMap;
        },
        getAllOrganizationMap() {
          // For Obex admin
          return organizations.getOrganizations().then(function (response) {
            const allOrganizationInfo = response.data;
            const allOrganizationMap = allOrganizationInfo.map(function (org) {
              return {
                name: org.Name,
                id: org.Id,
              };
            });
            console.log('Got All Organization Map');
            return $q.when(allOrganizationMap);
          });
        },
        setFilteredOrganization(id, name) {
          filtered_organization.id = id;
          filtered_organization.name = name
          storage.setItem('filter', JSON.stringify(filtered_organization));
          console.log('Filtered organization set to', filtered_organization);
          //console.log('localStorage set to ', JSON.parse(storage.getItem('filter')));
        },
        getFilteredOrganization() {
          let filtered = filtered_organization;
          if (filtered.id === undefined || filtered.name === undefined) {
            if (storage.getItem('filter')) {
              filtered = JSON.parse(storage.getItem('filter'));
            }
          }
          //console.log('Get Filtered Organization', filtered);
          return filtered;
        },
        clearFilteredOrganization() {
          filtered_organization.id = undefined;
          filtered_organization.name = undefined;
          storage.removeItem('filter');
          console.log('Filtered organization cleared');
        },
      };
    }])
})();


// WEBPACK FOOTER //
// ./client/js/services/orgFilter.service.js